// extracted by mini-css-extract-plugin
export default {"green":"styles_green__jkkPa","yellow":"styles_yellow__xbmqD","smallCard":"styles_smallCard__PxhDj"};